import { FieldValues, Path, PathValue } from 'react-hook-form';

interface SetCheckPointRequiredFieldsProps<TSchema extends FieldValues> {
  setValue: (
    name: Path<TSchema>,
    value: PathValue<TSchema, Path<TSchema>>
  ) => void;
  data: TSchema;
  translatedItem?: TSchema;
}

export const setCheckPointRequiredFields = <TSchema extends FieldValues>({
  setValue,
  data,
  translatedItem,
}: SetCheckPointRequiredFieldsProps<TSchema>) => {
  setValue('reportIcon' as Path<TSchema>, data.reportIcon ?? '');
  setValue('appIcon' as Path<TSchema>, data.appIcon ?? '');
  setValue('name' as Path<TSchema>, (translatedItem?.name || data.name) ?? '');
  setValue('type' as Path<TSchema>, data.type ?? '');
};
